import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import RadioGroup from '../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { galleyImageOptions } from './views/galley'

class XP55Galley extends Component {
    constructor(props) {
        super(props);
        this.handleGalleyChange = this.handleGalleyChange.bind(this);
        this.handleLayoutChange = this.handleLayoutChange.bind(this);
    }


    handleGalleyChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Worktop = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }


    handleLayoutChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Layout = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = galleyImageOptions;

        let image = <ConfiguratorImage boat="XP55" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='GALLEY' /></h1>

                    <MaterialSelector label={this.props.configuration.Worktop.label} options={this.props.worktopOptions} value={this.props.configuration.Worktop} onChange={this.handleGalleyChange} />

                    <h2><Trans defaults='Layout' /></h2>
                    <p><Trans defaults='Alternative layout = optional port aft head & reduced length of galley' /></p>
                    <RadioGroup options={this.props.layoutOptions} value={this.props.configuration.Layout} onChange={this.handleLayoutChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XP55Galley);


// WEBPACK FOOTER //
// ./src/XP55/XP55Galley.js